import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingAnimation from '../../components/LoadingAnimation';
import { useStores } from '../../context/context';

function Logout() {
  const { authStore } = useStores();
  const navigate = useNavigate();

  useEffect(() => {
    async function doLogout() {
      await authStore.logout();
      if (!authStore.isAuthenticated) {
        if (window.isNativeApp) {
          window.ReactNativeWebView.postMessage('logout_success');
        } else {
          navigate('/');
        }
      }
    }
    doLogout();
  }, []);

  return (
    <div>
      <LoadingAnimation />
    </div>
  );
}

export default Logout;
